import { render, staticRenderFns } from "./crmAside.vue?vue&type=template&id=48245f30&"
import script from "./crmAside.vue?vue&type=script&lang=js&"
export * from "./crmAside.vue?vue&type=script&lang=js&"
import style0 from "./crmAside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports